import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import useSEO from '../hooks/useSEO';

// Shown for any address the app doesn't know. The web server also returns a
// real 404 status for these (see nginx.conf), and the page is noindex, so
// search engines drop dead links instead of indexing an empty page.
const NotFoundPage: React.FC = () => {
    useSEO({
        title: 'صفحه پیدا نشد',
        noindex: true,
    });

    return (
        <Container maxWidth="sm" sx={{ py: { xs: 8, md: 12 }, textAlign: 'center' }}>
            <Typography variant="h2" sx={{ fontWeight: 800, color: '#2854a1', mb: 2 }}>
                404
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, direction: 'rtl' }}>
                صفحه مورد نظر پیدا نشد
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4 }}>
                The page you're looking for doesn't exist or has moved.
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
                <Button component={RouterLink} to="/" variant="contained">
                    صفحه اصلی / Home
                </Button>
                <Button component={RouterLink} to="/search" variant="outlined">
                    جستجوی کسب‌وکار / Search
                </Button>
            </Box>
        </Container>
    );
};

export default NotFoundPage;
